import { find } from "lodash";
import PubSub from "pubsub-js";

import PubSubTopics from "../constants/pubSubTopics";
import { tutorialOperations } from "../modules/tutorial";
import { isNativeCommsInstalled, nativeCommsBroadcastMessageTypes } from "../nativeComms";
import { tutorialGroups } from ".";

/**
 * Checks to see if an entire tutorial is complete, and adds that to the
 * list of resolved IDs if it is.
 *
 * This function will either call native code to handle our resolved tips
 * or it will return an action to be dispatched to the store (in browser)
 * @param {array} resolvedTips
 * @param {string} activeTutorial
 * @param {Set} completedSet
 */
const getActionForResolvedTips = (resolvedTips, activeTutorial, completedSet) => {
  let allResolvedTips = [...resolvedTips];
  if (allResolvedTips.length > 0 && activeTutorial) {
    // If something resolved, check to see if that means everything has resolved
    const group = tutorialGroups.byId[activeTutorial];
    const unfinishedTip = find(group.tips, tip => {
      return !completedSet.has(tip.id) && allResolvedTips.indexOf(tip.id) < 0;
    });
    if (!unfinishedTip) {
      allResolvedTips.push(activeTutorial);
    }
  }

  if (allResolvedTips.length) {
    // If we are in-app, send it to native to handle
    if (isNativeCommsInstalled()) {
      const stepIds = allResolvedTips.join(",");
      PubSub.publish(PubSubTopics.sendNativeMessage, {
        msg: nativeCommsBroadcastMessageTypes.MARK_TUTORIAL_STEPS_COMPLETE,
        stepIds
      });
      // Since we sent it through to native, we don't need to handle it locally as well
      return null;
    } else {
      // For browser testing, we need an action to update the store ourselves
      return tutorialOperations.addCompletedTips(allResolvedTips);
    }
  }
};

export default getActionForResolvedTips;
